import React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import BoundedPageLayout from '../../../components/dashboard/BoundedPageLayout';
import PageHeader from '../../../components/dashboard/PageHeader';
import CampaignDetailContent from '../../../components/campaigns/CampaignDetailContent';
import { useCampaignQuery } from '../../../components/campaigns/useCampaignQuery';
import { campaignLabel } from '../../../components/campaigns/campaignLabel';

export default function CampaignDetail() {
  const { id } = useParams();
  const { t } = useTranslation();
  // Same query as CampaignDetailContent (deduped by react-query), only for the title.
  const { data } = useCampaignQuery(id);
  const title = campaignLabel(data) || t('campaigns.detailTitle');

  const header = (
    <PageHeader
      title={title}
      breadcrumbs={[
        { label: t('campaigns.breadcrumb.dashboard') },
        { label: t('nav.groups.service') },
        { label: t('campaigns.breadcrumb.list'), to: '/campaigns' },
        { label: title },
      ]}
    />
  );

  return (
    <BoundedPageLayout header={header}>
      <CampaignDetailContent
        uuid={id}
        renderActions={(campaign) => (
          <Button
            variant="contained"
            startIcon={<ForumOutlinedIcon />}
            component={RouterLink}
            to={`/leads?entry=campaign:${campaign.uuid}`}
          >
            {t('campaigns.actions.viewLeads')}
          </Button>
        )}
      />
    </BoundedPageLayout>
  );
}
